<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-col :span="5">
        <el-form-item label="房产" prop="propertyId">
          <el-select
            :value="propertyName"
            ref="propertySelectRef1"
            placeholder="请选择房产"
            style="width: 100%;"
            clearable
            @clear="clearProperty"
          >
            <el-option :value="propertyName" :label="propertyName">
              <el-tree
                ref="propertyTreeRef1"
                node-key="id"
                :props="treeProps"
                :load="lazyLoadPropertyTree"
                lazy
                @node-click="propertyNodeTreeClick1"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item label="包含/享受">
          <el-select v-model="query.includeOrShare">
            <el-option
              v-for="item in includeShareSelection"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="费项" prop="itemsetId">
          <el-select
            v-model="query.feeItemsetId"
            placeholder="请选择费项"
            style="width: 100%;"
            clearable
          >
            <el-option
              style="padding-left: 10px;"
              v-for="item in feeItemsetList"
              :key="item.feeItemsetId"
              :label="item.feeItemsetName"
              :value="item.feeItemsetId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item label="是否启用">
          <el-select v-model="query.validFlag" clearable placeholder="请选择">
            <el-option
              v-for="item in validFlagSelection"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="优惠政策名称">
          <el-input
            placeholder="可输入开头部分名称"
            size="small"
            clearable
            v-model="query.preferentName"
          />
        </el-form-item>
      </el-col>
      <el-col :span="4" offset="1">
        <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
        <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
      </el-col>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <!--<template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plainquery
          v-if="permission.feeitemsetpreferent_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>-->
      <template slot-scope="scope" slot="propertyIdForm">
        <el-select
          :value="propertyName1"
          ref="propertyAddParentNodeSelectRef"
          placeholder="请选择房产"
          clearable
          style="width: 100%;"
          :disabled="editDisable1"
        >
          <el-option :value="propertyName1" :label="propertyName1">
            <el-tree
              ref="propertyAddParentNodeTreeRef"
              node-key="id"
              :props="treeProps"
              :load="lazyLoadPropertyTreeEdit"
              lazy
              @node-click="propertyNodeTreeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="useTimeForm">
        <el-date-picker
          v-model="form.useTime"
          type="date"
          placeholder="启用日期"
          style="width: 100%;"
          value-format="yyyy-MM-dd 00:00:00"
          :disabled="viewForm"
          @change="validateForm('stopTime')"
        ></el-date-picker>
      </template>
      <template slot-scope="scope" slot="stopTimeForm">
        <el-date-picker
          v-model="form.stopTime"
          type="date"
          placeholder="停用日期"
          style="width: 100%;"
          value-format="yyyy-MM-dd 00:00:00"
          :disabled="viewForm"
          @change="validateForm('useTime')"
        ></el-date-picker>
      </template>
      <template slot-scope="scope" slot="feeItemsetIdForm">
        <el-select
          v-model="form.itemsetId"
          placeholder="请选择费项"
          style="width: 100%;"
          @change="itemsetChanged"
        >
          <el-option
            style="padding-left: 10px;"
            v-for="item in feeItemsetList2"
            :key="item.feeItemsetId"
            :label="item.feeItemsetName"
            :value="item.feeItemsetId"
          ></el-option>
        </el-select>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getList,
  getFeeItemsetList,
  getDetail,
  add,
  update,
  remove,
} from '@/api/v4ward/fee/feeitemsetpreferent';
import { mapGetters } from 'vuex';
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';

export default {
  data() {
    var inputNumber = (rule, value, callback) => {
      if ((typeof value !== 'number' && isNaN(value)) || value <= 0) {
        callback(new Error('请输入大于 0 的数字！'));
      } else {
        callback();
      }
    };
    return {
      form: {
        itemsetId: '',
      },
      query: {
        includeOrShare: 1,
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      propertyList: [],
      feeItemsetList: [],
      feeItemsetList2: [],
      validFlagSelection: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      includeShareSelection: [
        {
          label: '享受',
          value: 1,
        },
        {
          label: '包含',
          value: 0,
        },
      ],

      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        labelWidth: 110,
        dialogHeight: 420,
        dialogWidth: '50%',
        //searchBtn: true,
        //searchSize: 'mini',
        column: [
          {
            label: '房产节点名称',
            //prop: 'propertyName',
            prop: 'roomName',
            overHidden: true,
            addDisplay: false,
            editDisabled: true,
          },
          {
            label: '房产节点',
            prop: 'propertyId',
            formslot: true,
            viewDisplay: false,
            editDisplay: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请选择房产',
                trigger: 'change',
              },
            ],
          },
          {
            label: '费项',
            prop: 'feeItemsetId',
            formslot: true,
            viewDisplay: false,
            editDisplay: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请选择费项',
                trigger: 'change',
              },
            ],
          },
          {
            label: '费项名称',
            prop: 'feeItemsetName',
            overHidden: true,
            addDisplay: false,
            editDisabled: true,
          },
          {
            label: '优惠政策名称',
            prop: 'preferentName',
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入优惠政策名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '收费方式',
            prop: 'chargeType',
            hide: true,
            type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=charge_type',
            rules: [
              {
                required: true,
                message: '请选择收费方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '启用',
            prop: 'validFlag',
            width: 50,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            type: 'select',
            dicData: [
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ],
          },
          {
            label: '含本月',
            prop: 'includFlag',
            width: 64,
            type: 'select',
            valueDefault: 1,
            dicData: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 0,
              },
            ],
            rules: [
              {
                required: true,
                message: '请选择是否含本月',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费数',
            width: 70,
            prop: 'paycycleNum',
            rules: [
              {
                required: true,
                message: '请输入收费数',
                trigger: 'blur',
              },
              {
                validator: inputNumber,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '优惠方式',
            prop: 'preferentType',
            width: 80,
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=preferent_type',
            rules: [
              {
                required: true,
                message: '请选择优惠方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠数额',
            prop: 'preferentScore',
            placeholder: '现金折扣时如打9折，输入0.9',
            width: 80,
            rules: [
              {
                required: true,
                message: '请输入优惠数额',
                trigger: 'blur',
              },
              {
                validator: inputNumber,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '启用时间',
            prop: 'useTime',
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请选择启用日期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(value);
                  var dateEnd = Date.parse(this.form.stopTime);
                  if (dateStart >= dateEnd) {
                    callback(new Error('启用日期必须小于禁用日期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '禁用时间',
            prop: 'stopTime',
            type: 'date',
            hide: true,
            format: 'yyyy-MM-dd',
            width: 100,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请选择禁用日期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.useTime);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('禁用日期必须大于启用日期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠备注',
            prop: 'preferentRemark',
            overHidden: true,
            span: 24,
          },
        ],
      },
      ////
      propertyName: '',
      propertyName1: '',
      treeProps: {
        //标题
        label: 'objectFullName',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      ////
      data: [],
      viewForm: false,
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feeitemsetpreferent_add, false),
        viewBtn: this.vaildData(this.permission.feeitemsetpreferent_view, false),
        delBtn: this.vaildData(this.permission.feeitemsetpreferent_delete, false),
        editBtn: this.vaildData(this.permission.feeitemsetpreferent_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    //this.updateItemsetSelectionList();
  },
  methods: {
    itemsetChanged(value) {
      this.form.feeItemsetId = value;
    },
    validateForm(fieldName) {
      this.$refs.crud.validateField(fieldName);
    },
    ////////////
    lazyLoadPropertyTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      getTreeChildrenPowerNode({ id: id, power: 1, useType: 2 }).then(({ data }) => {
        resolve(data);
      });
    },
    lazyLoadPropertyTreeEdit(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      getTreeChildrenPowerNode({ id: id, power: 2, useType: 2 }).then(({ data }) => {
        resolve(data);
      });
    },
    propertyNodeTreeClick1(node) {
      this.query.propertyId = node[this.treeProps.value];
      this.propertyName = node[this.treeProps.label];
      this.updateItemsetSelectionList(this.query.propertyId);
    },
    clearProperty() {
      this.query.propertyId = '';
      this.propertyName = '';
      //this.updateItemsetSelectionList();
    },
    propertyNodeTreeClick(node) {
      this.propertyName1 = node[this.treeProps.label];
      this.form.propertyId = node[this.treeProps.value];
      this.updateItemsetSelectionList2(this.form.propertyId);
      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
        //this.propertyAddForm.parentId = nodeId;
        //this.propertyAddForm.parentObjectTypeName = nodeTypeName;
      }
    },
    ///////////////
    updateItemsetSelectionList2(propertyId) {
      getFeeItemsetList(propertyId, '1').then((data) => {
        this.feeItemsetList2 = data.data;
      });
    },
    updateItemsetSelectionList(propertyId) {
      getFeeItemsetList(propertyId).then((data) => {
        this.feeItemsetList = data.data;
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.viewForm = type === 'view';
      /*if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then((res) => {
          console.log(JSON.stringify(res));
          this.form = res;
        });
      }*/
      done();
    },
    searchReset() {
      console.log('==================++++++++++++++');
      this.propertyName = '';
      this.query = {};
      this.onLoad(this.page);
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  line-height: 25px;
  padding-left: 10px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-property-dialog-div {
  height: 500px;
  overflow: auto;
}
</style>
